var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[(_vm.responsiveState.isDesktop)?_c('HomeDesktop'):_c('HomeMobile')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }